import { h } from "preact";

import { classNames } from "../helpers";
import Star from "./Star.jsx";

const MAX_RATING = 5;

export default function Rating({ value, ...props }) {
  const classes = classNames("rating", props.class);
  const stars = [];

  for (let i = 0; i < Math.floor(value); i++) {
    stars.push(<Star full />);
  }
  if (Math.floor(MAX_RATING - value) + Math.floor(value) < MAX_RATING) {
    stars.push(<Star half />);
  }
  for (let i = 0; i < Math.floor(MAX_RATING - value); i++) {
    stars.push(<Star empty />);
  }

  return <span class={classes}>{stars}</span>;
}
